import { createContext, useContext } from "react";
export var ChatSideEffectContext = createContext(function() {});
export function useChatSideEffect() {
    return useContext(ChatSideEffectContext);
}
